import { ExternalLink, BookOpen, Phone } from "lucide-react";
import SEO from "../components/SEO";
import { COMPANY } from "../lib/constants";

const RESOURCES = [
  { name: "Adult Protective Services", url: "https://www.vadars.org/" },
  { name: "Albemarle County Government", url: "https://www.albemarle.org/" },
  { name: "American Federation for Aging Research", url: "https://www.infoaging.org/" },
  { name: "American Health Care Association", url: "https://www.ahcancal.org/" },
  { name: "Caregiving — Insights, Information, Inspirations", url: "https://www.caregiving.com/" },
  { name: "City of Charlottesville, Virginia", url: "https://www.charlottesville.gov/" },
  { name: "City of Danville, Virginia", url: "https://www.danville-va.gov/" },
  { name: "Fairfax County Government", url: "https://www.fairfaxcounty.gov/" },
  { name: "National Association for Home Care & Hospice", url: "https://www.nahc.org/" },
  { name: "Northern Virginia Counties — Your At Home Team", url: "https://www.yourathometeam.com/blog/northern-virginia-counties" },
  { name: "Prince William County Government", url: "https://www.pwcva.gov/" },
  { name: "U.S. Department of Health & Human Services", url: "https://www.hhs.gov/" },
  { name: "Virginia Managed Care", url: "https://www.virginiamanagedcare.com/" },
  { name: "Medicare.gov — Official U.S. Government Site", url: "https://www.medicare.gov/" },
  { name: "Virginia Medicaid (DMAS)", url: "https://www.dmas.virginia.gov/" },
  { name: "Alzheimer's Association", url: "https://www.alz.org/" },
  { name: "AARP — Caregiving Resources", url: "https://www.aarp.org/caregiving/" },
];

export default function Resources() {
  return (
    <>
      <SEO
        title="Resources | 1st Home Care Services — Caregiving & Senior Care in Virginia"
        description="Helpful resources for caregiving and senior care in Northern Virginia — including Adult Protective Services, Fairfax County, Medicare, Medicaid, and trusted aging organizations."
        canonical="https://1sthomecare.com/resources"
      />

      <section className="container-pad section-pad">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-widest text-brand-amber mb-3">
            Resources
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-brand-blue-dark text-balance">
            Elderly care in Northern Virginia
          </h1>
          <p className="mt-6 text-lg text-gray-600 leading-relaxed">
            We've compiled trusted external resources so you can get all the
            information you need about caregiving and senior care — from county
            and state programs to national aging organizations.
          </p>
        </div>
      </section>

      <section className="container-pad pb-16 md:pb-24">
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 md:p-10">
          <ul
            data-testid="resources-list"
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3"
          >
            {RESOURCES.map((r) => (
              <li key={r.url}>
                <a
                  href={r.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`resource-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 50)}`}
                  className="group flex items-start gap-3 p-4 rounded-xl bg-brand-gray/50 hover:bg-brand-blue hover:text-white border border-transparent hover:border-brand-blue-dark transition-all"
                >
                  <BookOpen className="w-5 h-5 text-brand-amber-dark group-hover:text-brand-amber-light mt-0.5 shrink-0" />
                  <span className="flex-1 text-sm font-medium leading-snug">{r.name}</span>
                  <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-white shrink-0 mt-0.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-brand-gray/40 section-pad">
        <div className="container-pad text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-brand-blue-dark">
            For more information, please call us
          </h2>
          <div className="mt-6">
            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="resources-call-now"
              className="inline-flex items-center gap-2 bg-brand-blue text-white font-semibold px-7 py-4 rounded-full shadow-md hover:bg-brand-blue-dark"
            >
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
